<mat-card style="height: 410px;max-height:600px;width:100%;padding-right: 0px;padding-left: 0px">
  <form #loginForm="ngForm" enctype="multipart/form-data">
   <mat-toolbar>
    {{ 'manageCalendar.titol' | translate }}
    <span class="fill-remaining-space" style="margin-left: 20px">({{nom}})</span>
    <div style="width:100%;float:right">
      <button mat-icon-button (click)="this.tancar()" style="float: right; margin-right: 0"><mat-icon color="primary" style="font-size:24px" title="{{ 'common.tancar' | translate }}">close</mat-icon></button>
      <button mat-icon-button (click)="this.desar()" style="float: right; margin-right: 0"><mat-icon color="primary" style="font-size:24px" title="{{ 'common.desar' | translate }}">save</mat-icon></button>
    </div> 
   </mat-toolbar>
   <mat-card-content style="float:left;clear:left;width:80%;padding-top: 15px;">
<div class="calendar">
  <div class="calendar-navs">
    <div class="month-nav">
      <button mat-button (click)="prevMonth()">&lt;</button>
      <span class="p4">{{ currentDate.locale('ca').format('MMMM').charAt(0).toUpperCase()+currentDate.locale('ca').format('MMMM').substr(1) }}</span>
      <button mat-button (click)="nextMonth()">&gt;</button>
    </div>
    <div class="year-nav">
      <button mat-button (click)="prevYear()">&lt;</button>
      <span>{{ currentDate.format('YYYY') }}</span>
      <button mat-button (click)="nextYear()">&gt;</button>
    </div>
  </div>
  <div class="month-grid">
    <div class="day-names">
      <div *ngFor="let name of dayNames" class="day-name p9">
        {{ name.charAt(0).toUpperCase()+name.substr(1) }}
      </div>
    </div>
    <div class="weeks">
      <div *ngFor="let week of weeks;let i = index" class="week">
        <ng-container *ngFor="let day of week;let j = index">
          <div class="week-date disabled" *ngIf="!isSelectedMonth(day.mDate)">
            <span class="date-text">{{ day.mDate.date() }}</span>
          </div>
          <div class="week-date enabled"
            *ngIf="isSelectedMonth(day.mDate)"
            (click)="onMouseClick($event, day.mDate, i*7+(j+1))"
            [ngClass]="{ today: day.today, selected: day.selected }"
            [style.color]="colorText[i*7+(j+1)]"
            [ngStyle]="{'border': '4px solid' + incidenciaSelectedAdmColor(i,j,day.mDate)}"
           >
           <div *ngIf="!isSelectedUsu(day.mDate)" class="date-text">{{ day.mDate.date() }}</div>
           <button mat-mini-fab matTooltip="{{incidenciaSelectedUsuLabel(day.mDate)}}" mat-button *ngIf="isSelectedUsu(day.mDate)" color="incidenciaSelectedUsuColor(day.mDate)" [ngStyle]="{'border': '3px solid' + incidenciaSelectedUsuColor(day.mDate)}" class="date-text-round" title="{{incidenciaSelectedUsuObs(day.mDate)}}"><span style="display: inherit;margin-top: -24px">{{ day.mDate.date() }}</span></button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
<div style="float:left;clear:both;width:100%;padding:10px">
  <div style="float:left;clear:none">
      {{ 'manageCalendar.calendariLaboralText' | translate:{ any: currentDate.format('YYYY') } }}</div>
  <div style="float:left;clear:none;margin-top:-5px;margin-left:10px">
     <a href="./assets/Calendari_laboral.pdf" target="_blank"><mat-icon color="primary" style="font-size:24px" title="{{ 'manageCalendar.descarregarTitle' | translate }}">picture_as_pdf</mat-icon></a></div>
</div>
</mat-card-content>
<mat-card-content style="float:left;clear:none;width:19%;padding-top:40px">
  <mat-select style="float:left;clear:none;width:100%" [(ngModel)]="tipusIncidencia" name="tipusIncidencia" placeholder="{{ 'manageCalendar.tipusNombrePlaceholder' | translate }}">
    <mat-option *ngFor="let tipus of tipusDies" [value]="tipus.id"><div style="float:left;clear:none;display:block;width:15px;height: 15px;border-radius: 50%;margin-right:10px;margin-top:17px" [ngStyle]="{'background-color': tipus.color}"></div><div style="float:left;clear:none;font-size:0.85em">{{getLegend(tipus.id)}}</div>
    </mat-option>
  </mat-select>
</mat-card-content>
</form>
<mat-card-content *ngIf="display" (event)="false" id="dlgObs" class="dialeg-back" style="background-color: rgba(200, 200, 200, .4)">
 <mat-card-content class="dialeg">
  <form #loginForm="ngForm">
  <mat-toolbar>
    {{ 'manageCalendar.observacionsTitol' | translate }}
    <div style="width:100%;float:right">
      <button mat-icon-button style="width:40px; float: right; margin-right: 0"><mat-icon color="primary" style="font-size:24px" title="{{ 'common.tancar' | translate }}" (click)="desarObs($event)">close</mat-icon></button>
      <button mat-icon-button style="width:40px; float: right; margin-right: 0"><mat-icon color="primary" style="font-size:24px" title="{{ 'common.desar' | translate }}" (click)="desarObs($event)">check</mat-icon></button>
    </div> 
  </mat-toolbar>
  <div style="width:100%;padding-top:5px">
    <mat-form-field style="width: 100%">
      <textarea [(ngModel)]="observacions" matInput placeholder="{{ 'manageCalendar.observacionsTitol' | translate }}" name="observacions" rows="4" style="width: 100%"></textarea>
    </mat-form-field> 
  </div>
  </form>
 </mat-card-content>
</mat-card-content>
</mat-card>
